// removed by extract-text-webpack-plugin
module.exports = {"base":"VehicleAddToComparison_base--MGxOE"};


//////////////////
// WEBPACK FOOTER
// ./components/VehicleAddToComparison/VehicleAddToComparison.scss
// module id = 2438
// module chunks = 11